var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LControl',{staticClass:"leaflet-control leaflet-control--logout",attrs:{"position":"topright"}},[_c('button',{staticClass:"leaflet-control__button",on:{"click":_vm.handleLogout}},[_c('Icon',{attrs:{"icon":"logout"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }